import {Pipe, Injectable, PipeTransform} from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {Utils} from '../../providers/service/utils';

/**
 * Generated class for the DateFormatePipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'dateformate',
})
export class DateFormatePipe implements PipeTransform {
  transform( dateContent:string) {
    //正则判断时间格式：2010-03-15 10:30:00
    var reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;

    if(dateContent == null ){
      return "未知时间";
    }if(reg.test(dateContent)){
      // dateContent = dateContent.replace(/-/g,'/');
      // var dateContentTime = (new Date(dateContent)).getTime();
      var dateContentTime = this.getTs(dateContent);
      return Utils.formateTimeGap(dateContentTime);
    }else{
      return Utils.formateTimeGap(parseInt(dateContent));
    }
   
  }

  // ios 时间转时间戳  
// 兼容所有浏览器  
// ios 使用 new Date("2010-03-15 10:30:00").getTime() 获取时间戳报错  
// @time "2010-03-15 10:30:00"  
getTs(time){  
  var arr = time.split(/[- :]/);
  const _date:any = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
  const timeStr = Date.parse(_date)  ;
  return timeStr  ;
} 

}



// WEBPACK FOOTER //
// ./src/pipes/date-formate/date-formate.ts